import { Component, OnInit } from '@angular/core';
import { RolesService } from 'src/app/services/roles.service';
import { MatDialogRef } from '@angular/material/dialog';
import { RolesMainComponent } from '../roles-main/roles-main.component';

@Component({
  selector: 'app-add-role',
  templateUrl: './add-role.component.html',
  styleUrls: ['./add-role.component.css']
})
export class AddRoleComponent implements OnInit {

  RoleName:string = ""
  submitted = false
  PermissionsName = "Choose Permission"
  all_premiosn:any
  permiosn_choice:any = []
  permissions_arr:any = []
  constructor(private rest : RolesService , public dialogRef: MatDialogRef<RolesMainComponent>,){}

  ngOnInit(){
    this.getPermiosn()
  }

  getPermiosn(){
    this.rest.retrivePermison().subscribe((res:any) => {
      console.log(res)
      this.all_premiosn = res
    })
  }

  getPerItem(item:any){
    this.permiosn_choice.push(item)
  }

  addrole(){
    console.log(this.permissions_arr)
    this.submitted = true
    console.log(this.RoleName)
    if(this.RoleName != "" && this.permissions_arr.length != 0 ){
      let data = {
        name : this.RoleName,
        permiosn : this.permissions_arr
      }
      this.dialogRef.close(data);
    }

  }

  getInput(event:any){
    this.RoleName = event.target.value
  }

}
